"use client";

import { ArrowLeft, FileQuestion } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";

import { orgAuthRoute } from "@/config/routes";
import { getSubdomain } from "@/lib/utils";

export default function NotFound() {
  const [mounted, setMounted] = useState(false);
  const [isTenant, setIsTenant] = useState(false);

  // Ensure hydration
  useEffect(() => {
    setMounted(true);

    // Check if URL is a tenant URL (subdomain format)
    const hostname = window.location.hostname;
    const subdomain = getSubdomain(hostname);

    setIsTenant(!!subdomain);
  }, []);
  if (!mounted) return null;

  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-background text-foreground">
      <div className="container flex max-w-[64rem] flex-col items-center justify-center gap-4 text-center">
        <div className="relative mb-4">
          <div className="absolute -inset-0.5 rounded-lg bg-gradient-to-r from-primary to-green-700 opacity-75 blur-xl"></div>
          <div className="relative flex h-32 w-32 items-center justify-center rounded-lg bg-background">
            <FileQuestion className="h-16 w-16 text-primary" />
          </div>
        </div>

        <h1 className="text-8xl font-extrabold tracking-tighter sm:text-9xl">
          <span className="bg-gradient-to-r from-primary to-green-700 bg-clip-text text-transparent">
            404
          </span>
        </h1>

        <p className="max-w-[42rem] text-muted-foreground sm:text-xl">
          Oops! The page you&apos;re looking for seems to have wandered off.
        </p>

        <div className="mt-8 flex flex-col gap-2 sm:flex-row">
          <Button
            asChild
            size="lg"
            className="gap-2 bg-primary hover:bg-primary/90"
          >
            <Link href={isTenant ? orgAuthRoute.login : "/"}>
              <ArrowLeft className="h-4 w-4" />
              Back to Home
            </Link>
          </Button>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute left-0 top-0 -z-10 h-full w-full">
        <div className="absolute left-1/4 top-1/4 h-32 w-32 rounded-full bg-primary/10"></div>
        <div className="absolute bottom-1/4 right-1/4 h-40 w-40 rounded-full bg-primary/10"></div>
        <div className="absolute bottom-1/3 left-1/3 h-24 w-24 rounded-full bg-primary/10"></div>
      </div>
    </div>
  );
}
